import * as React from 'react';
import { Rectangle } from '../Rectangle/Rectangle';
import { Text } from '../Text';
import { TypeDisplay } from '../../LibraryView/ApiSectionView/PropertiesList/Property/TypeDisplay';
import { Caption } from '../Caption';
import style from './typeRectangle.scss';
import { TypeMembersTable } from './TypeMembersTable';
import { ShowMembersButton } from './ShowMembersButton';
import { StoreContext } from '../../../appContext/StoreProvider';
import { Collapse } from 'wix-style-react';
import { TypeInServiceJson, TypeParameter } from '../../TypeDetails/typeParser';
import { getReferencesToMessagesInType } from '../../../../utils/typeUtils';

interface TypeRectangleProps {
  title: string;
  pageName: string;
  prefix: string;
  displayName: string;
  type: TypeInServiceJson;
  className?: string;
  label?: string; // label to show below the type
  isResponse?: boolean; // we need this for the nested table that for response presentation
  JSLayoutType?: boolean;
}

export const TypeRectangle = ({
  title,
  type = [],
  label,
  className,
  displayName,
  prefix,
  pageName,
  isResponse,
  JSLayoutType,
}: TypeRectangleProps) => {
  const { store } = React.useContext(StoreContext);
  const [showMembers, setShowMembers] = React.useState(true);
  const referencesToMessagesInType = Array.isArray(type)
    ? getReferencesToMessagesInType(type, store)
    : getReferencesToMessagesInType([type], store);

  const typeHasReferencesToMessagesWithMembers =
    referencesToMessagesInType.length > 0;

  const typeRectangleClassName = `${style.typeRectangle} ${
    typeHasReferencesToMessagesWithMembers ? style.complexType : ''
  }`;

  return (
    <span className="notranslate">
      <Rectangle
        dataHook="type-rectangle"
        className={
          className
            ? `${typeRectangleClassName} ${className}`
            : typeRectangleClassName
        }
      >
        <div className={style.text}>
          {title && (
            <Text dataHook="title" weight="bold">
              {title}
            </Text>
          )}
          {(!!type || !!label) && (
            <div className={style.details} data-hook="type-details">
              {!!type && (
                <TypeDisplay
                  type={type}
                  displayName={
                    displayName || (type as TypeParameter).displayName
                  }
                  JSLayoutType={JSLayoutType}
                />
              )}
              {!!label && <Caption dataHook="label">{label}</Caption>}
            </div>
          )}
        </div>
        {typeHasReferencesToMessagesWithMembers && (
          <div className={style.button}>
            <ShowMembersButton
              text={showMembers ? 'Hide Members' : 'Show Members'}
              onClick={() => setShowMembers(!showMembers)}
              showMembers={showMembers}
            />
          </div>
        )}
      </Rectangle>
      {typeHasReferencesToMessagesWithMembers && (
        <Collapse open={showMembers} dataHook="collapse-type-members-table">
          <div>
            <TypeMembersTable
              type={referencesToMessagesInType}
              prefix={prefix}
              pageName={pageName}
              isResponse={isResponse}
              JSLayoutType={JSLayoutType}
            />
          </div>
        </Collapse>
      )}
    </span>
  );
};
